
const srcOptions = [
    {
        id:1,
        text:"SRC1: Uluslararası Yolcu Taşıma",
        value: "Src1"
    },
    {
        id:2,
        text:"SRC2: Yurtiçi Yolcu Taşıma",
        value: "Src2"
    },
    {
        id:3,
        text:"SRC3: Uluslararası Yük Taşıma",
        value: "Src3"
    },
    {
        id:4,
        text:"SRC4: Yurtiçi Yük Taşıma",
        value: "Src4"
    },
    {
        id:5,
        text:"SRC5: (ADR)Tehlikeli Madde Taşıma",
        value: "Src5"
    },
    {
        id:6,
        text:"Yok",
        value: "yok"
    }
]

export default srcOptions